import * as types from "./types";

const mutations = {
  [types.LOADING_MODULECONFIG](state, value) {
    state.loading = value;
  },
  [types.GET_MODULECONFIG_LIST](state, configs) {
    state.itemuom = configs; // Store the configs array in state
  },
};

export default mutations;
